import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Grid, makeStyles, Typography } from '@material-ui/core';

const useStyle = makeStyles(() => ({
  container: {
    marginTop: 10,
    marginBottom: 10,
  },
  message: { fontSize: 13, color: '#623601' },
}));

type Props = {
  groupID?: string | null;
};

const MessageWarning = ({ groupID }: Props): JSX.Element => {
  const classes = useStyle();
  return (
    <>
      {groupID === null && (
        <Grid item xs={12} className={classes.container}>
          <Box
            style={{
              backgroundColor: '#FFEFD0',
              paddingTop: 8,
              paddingBottom: 8,
              paddingRight: 15,
              paddingLeft: 15,
            }}
            sx={{ borderRadius: 4 }}
            data-testid="message-damage-to-third-parties"
          >
            <FontAwesomeIcon
              icon={faTriangleExclamation}
              fontSize={16}
              color="#E37E07"
              style={{ marginRight: 10 }}
            />
            <Typography variant="inherit" style={{ color: '#623601' }}>
              Este modelo está disponible para cotizar Daños a Terceros
              solamente.
            </Typography>
          </Box>
        </Grid>
      )}
    </>
  );
};

export default MessageWarning;
